<!-- 1 -->
<!-- <div class="center-box">
  <mat-card class="simple-card">
    <h2>Unsubscribe Mail Preview</h2>
    <p>
      This is a placeholder to preview how your unsubscribe section will look
      in the final email template.
    </p>
  </mat-card>
</div> -->

<!-- 2 -->
@if (logsDetails) {
<div class="container">
  <mat-card class="unsubscribe-card">
    <mat-card-header>
      <mat-icon class="success-icon">check_circle</mat-icon>
    </mat-card-header>
    <mat-card-content>
      <h2>Successfully Unsubscribed</h2>
      <p class="message">
        You have been removed from our mailing list. You will no longer receive 
        promotional emails from us.
      </p>
      <p class="sub-message">
        We're sorry to see you go, but we respect your decision.
      </p>
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button color="primary" (click)="return()">
        Return to Home
      </button>
    </mat-card-actions>
  </mat-card>
</div>
}

<!-- 3 -->
 <!-- Alternative design with info theme -->
<!-- <div class="container-alt">
  <mat-card class="info-card">
    <div class="icon-wrapper">
      <mat-icon class="mail-icon">mail_outline</mat-icon>
      <mat-icon class="unsubscribe-icon">unsubscribe</mat-icon>
    </div>
    <mat-card-content>
      <h1>Unsubscribe Confirmation</h1>
      <div class="divider"></div>
      <p class="main-text">
        Your email address has been successfully removed from our mailing list.
      </p>
      <mat-list class="info-list">
        <mat-list-item>
          <mat-icon matListItemIcon>done</mat-icon>
          <span matListItemTitle>No more promotional emails</span>
        </mat-list-item>
        <mat-list-item>
          <mat-icon matListItemIcon>done</mat-icon>
          <span matListItemTitle>Changes effective immediately</span>
        </mat-list-item>
        <mat-list-item>
          <mat-icon matListItemIcon>info</mat-icon>
          <span matListItemTitle>You may still receive transactional emails</span>
        </mat-list-item>
      </mat-list>
      <p class="footer-text">
        Changed your mind? You can always resubscribe from your account settings.
      </p>
    </mat-card-content>
  </mat-card>
</div> -->